module.exports = __webpack_public_path__ + "media/images/bg-description-d04008d78961bf43063344de0252c60c.png";